<div class="dropdown">
   <!-- Dropdown toggle -->
   <div class="c-dropdown-toggle" data-bs-toggle="dropdown">
      <!-- <span class="user-name">
         {{ userAcronym }}
      </span> -->
      <img src='assets/icons/account-circle.svg'>
      <span class="dropdown-label" i18n="@@myProfile">My Profile</span>
      <div class="arrow-container">
         <img src="assets/icons/arrow-down-blue.svg" />
      </div>
   </div>

   <!-- Dropdown menu -->
   <div class="dropdown-menu">
      <div class="menu-container">
         <!-- Profile Image -->
         <div class="top">
            <!-- <div class="profile-image">
               <img [src]="user.imageUrl" onerror="this.src='assets/icons/user-blue-menu.svg'" />
            </div> -->

            <!-- User Info -->
            <div class="user-details">
               <span class="user-name">
                  {{ user.fullname }}
               </span>
               <span class="user-contact">
                  {{ user.fullMobileNumber }}
               </span>
               <!-- <span class="user-email ellipsis" data-bs-toggle="user.email.length > 25 ? 'tooltip' : 'disable'"
                  title="{{ user.email }}">
                  {{ user.email }}
               </span> -->
            </div>
         </div>

         <!-- Divider -->
         <!-- <div class="divider">
            <div class="line"></div>
         </div> -->

         <!-- Menu -->
         <div class="dropdown-menu-body">
            <!-- <a class="dropdown-item" (click)="navigateTo(profileUrl)">
                <div class="img-container">
                   <img class="dropdown-icon profile" src="assets/icons/user-profile-gray.svg" />
                </div>
                
                <span i18n="@@myProfileHeader">My Profile</span>
             </a>
             <a class="dropdown-item" (click)="onLogout()">
                <div class="img-container">
                   <img class="dropdown-icon profile" src="assets/icons/logout-grey.svg" />
                </div>
                <span i18n="@@signOut">Sign out</span>
             </a> -->
            <!-- <a class="dropdown-item">
               <div class="account-details">
                  <h4>Account</h4>
                  @for(customer of customers; track $index) {
                  <div class="account-id-name" (click)=" customerStore.selectCustomer((customer.customerId))">
                     <div class="inner">
                        <div class="account-id">
                           <h5>Account ID <span>{{ customer.legacyId }}</span></h5>
                        </div>
                        <h6 class="account-name">{{ customer.name }}</h6>
                     </div>
                     <div>
                        @if(customer.customerId == customerStore.selectedCustomerId) {
                           <img src="assets/icons/blue-check.svg" alt="">
                        }
                     </div>
                  </div>
                  }

               </div>
            </a> -->
            <div class="links-and-logout">
               <div class="links">
                  <a (click)="goToUserProfile()"><h3 i18n="@@userProfile">User Profile</h3></a>
                  <!-- <a><h3>Password & Security</h3></a>
                  <a><h3>Communication Preferences</h3></a> -->
               </div>
               <avenir-button [theme]="BUTTON_THEME.WHITE" class="logout-btn" [label]="'Logout'" (onClick)="onLogout()"></avenir-button>
            </div>
         </div>
      </div>
   </div>
</div>